// config/api.ts

const isDev = import.meta.env.DEV;

export const AUTH_API_URL = `https://api.izilifepay.com/api`;

export const MAIN_URL = isDev ? "http://localhost:8000" : "https://api-ops.kafintechgroup.com";

export const MAIN_API_URL = `${MAIN_URL}/api`;

export const BACKEND_URL = `https://api.izilifepay.com/api`;

export const API_BASE = `https://api.izilifepay.com`;

export const FRONTEND_URL = `https://ops.kafintechgroup.com`;
